import { Box as ChakraBox, ComponentWithAs, BoxProps as Props } from "@chakra-ui/react";

export interface BoxProps extends Props {}

/**
 * Box is the most abstract component on top of which all other components are built. By default, it renders a div element.
 */
export const Box = ChakraBox as ComponentWithAs<"div", BoxProps>;
